// extracted by mini-css-extract-plugin
module.exports = {"skip":"Skip_skip__vxe0z"};